"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Tooltip = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var classnames_1 = __importDefault(require("classnames"));
var react_popper_1 = require("react-popper");
var AppearanceAnim_1 = require("./AppearanceAnim");
var useUuid_1 = require("./useUuid");
var isSemanticElement_1 = require("./utils/isSemanticElement");
var Tooltip_module_scss_1 = __importDefault(require("./Tooltip.module.scss"));
var positionToPlacement = new Map([
    ["above", "top"],
    ["below", "bottom"],
    ["left", "left"],
    ["right", "right"],
]);
// Sync with Tooltip.scss
var arrowHeight = 7;
var arrowWidth = 14;
var TooltipContent = function (_a) {
    var position = _a.position, text = _a.text, referenceElement = _a.referenceElement, tooltipId = _a.tooltipId, _b = _a.mood, mood = _b === void 0 ? "default" : _b;
    var _c = (0, react_1.useState)(null), popperElement = _c[0], setPopperElement = _c[1];
    var _d = (0, react_1.useState)(null), arrowElement = _d[0], setArrowElement = _d[1];
    var _e = (0, react_popper_1.usePopper)(referenceElement, popperElement, {
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement,
                    // Ensures that the arrow doesn't go too far to the left or right
                    // of the tooltip.
                    padding: arrowWidth / 2 + 10
                }
            },
            {
                name: "offset",
                options: {
                    offset: [0, arrowHeight + 6]
                }
            },
            {
                name: "preventOverflow",
                options: {
                    // Makes sure that the tooltip isn't flush up against the end of the
                    // viewport
                    padding: 8,
                    altAxis: true,
                    altBoundary: true,
                    tetherOffset: 50
                }
            },
            {
                name: "flip",
                options: {
                    padding: 8,
                    altBoundary: true,
                    fallbackPlacements: ["left", "top", "bottom", "right"]
                }
            },
        ],
        placement: position ? positionToPlacement.get(position) : undefined
    }), popperStyles = _e.styles, attributes = _e.attributes;
    var _f = (0, AppearanceAnim_1.useAnimation)(), isVisible = _f.isVisible, isAnimIn = _f.isAnimIn, isAnimOut = _f.isAnimOut;
    return isVisible || isAnimOut || isAnimIn ? (react_1["default"].createElement("div", __assign({ ref: setPopperElement, className: Tooltip_module_scss_1["default"].tooltip, style: popperStyles.popper }, attributes.popper, { role: "tooltip", id: tooltipId }),
        react_1["default"].createElement("div", { className: (0, classnames_1["default"])(Tooltip_module_scss_1["default"].tooltipContent, Tooltip_module_scss_1["default"][mood]) }, text),
        react_1["default"].createElement("div", { ref: setArrowElement, className: Tooltip_module_scss_1["default"].arrow, style: popperStyles.arrow },
            react_1["default"].createElement("div", { className: Tooltip_module_scss_1["default"].arrowInner },
                react_1["default"].createElement("div", { className: (0, classnames_1["default"])(Tooltip_module_scss_1["default"].arrowMain, Tooltip_module_scss_1["default"][mood]) }),
                react_1["default"].createElement("div", { className: Tooltip_module_scss_1["default"].arrowShadow }))))) : null;
};
var renderChildren = function (content, tooltipId, hasActiveTooltip) {
    if ((0, isSemanticElement_1.isSemanticElement)(content)) {
        return (0, react_1.cloneElement)(content, {
            "aria-describedby": hasActiveTooltip ? tooltipId : undefined
        });
    }
    // We don't want to block them from this but just provide context for better a11y guidance
    // eslint-disable-next-line no-console
    console.warn("<Tooltip /> is not directly wrapping a semantic element, screen reader users will not be able to access the tooltip info. To ensure accessibility, Tooltip should be wrapping a semantic and focusable element directly.");
    return content;
};
/**
 * @deprecated Please use the same component from `@kaizen/components`
 */
var Tooltip = function (_a) {
    var children = _a.children, text = _a.text, inline = _a.inline, _b = _a.display, display = _b === void 0 ? "block" : _b, _c = _a.position, position = _c === void 0 ? "above" : _c, classNameOverride = _a.classNameOverride, portalSelector = _a.portalSelector, animationDuration = _a.animationDuration, _d = _a.isInitiallyVisible, isInitiallyVisible = _d === void 0 ? false : _d, _e = _a.mood, mood = _e === void 0 ? "default" : _e;
    var _f = (0, react_1.useState)(isInitiallyVisible), isHover = _f[0], setIsHover = _f[1];
    var _g = (0, react_1.useState)(false), isFocus = _g[0], setIsFocus = _g[1];
    var _h = (0, react_1.useState)(null), referenceElement = _h[0], setReferenceElement = _h[1];
    var tooltipId = (0, useUuid_1.useUuid)();
    var hasActiveTooltip = isHover || isFocus;
    var tooltip = (react_1["default"].createElement(TooltipContent, { text: text, position: position, referenceElement: referenceElement, tooltipId: tooltipId, mood: mood }));
    var portalSelectorElementRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        portalSelectorElementRef.current = portalSelector
            ? document.querySelector(portalSelector)
            : null;
    }, [portalSelector]);
    (0, react_1.useEffect)(function () {
        if (portalSelector && !portalSelectorElementRef.current) {
            // eslint-disable-next-line no-console
            console.warn("The portal could not be created using the selector: " + portalSelector);
        }
    }, [portalSelectorElementRef, portalSelector]);
    // Legacy support for the inline prop
    var displayToUse = inline != null ? (inline ? "inline" : "block") : display;
    var getDisplayClassName = function () {
        switch (displayToUse) {
            case "inline":
                return Tooltip_module_scss_1["default"].displayInline;
            case "block":
                return Tooltip_module_scss_1["default"].displayBlock;
            case "inline-block":
                return Tooltip_module_scss_1["default"].displayInlineBlock;
            case "flex":
                return Tooltip_module_scss_1["default"].displayFlex;
            case "inline-flex":
                return Tooltip_module_scss_1["default"].displayInlineFlex;
            default:
                return undefined;
        }
    };
    return (react_1["default"].createElement(AppearanceAnim_1.AnimationProvider, { isVisible: hasActiveTooltip, animationDuration: animationDuration },
        react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement("div", { ref: setReferenceElement, className: (0, classnames_1["default"])(classNameOverride, getDisplayClassName()), onMouseEnter: function () { return setIsHover(true); }, onMouseLeave: function () { return setIsHover(false); }, onFocusCapture: function () { return setIsFocus(true); }, onBlurCapture: function () { return setIsFocus(false); } }, renderChildren(children, tooltipId, hasActiveTooltip)),
            portalSelector && portalSelectorElementRef.current
                ? react_dom_1["default"].createPortal(tooltip, portalSelectorElementRef.current)
                : tooltip)));
};
exports.Tooltip = Tooltip;
exports.Tooltip.displayName = "Tooltip";
//# sourceMappingURL=Tooltip.js.map